import React from 'react';
import PropTypes from 'prop-types';
import { LinkStyled, AStyled } from './Link.styled';

const Link = ({
  content, to, href, target,
}) => (
  href ? (
    <AStyled href={href} target={target}>
      {content}
    </AStyled>
  ) : (
    <LinkStyled to={to} target={target}>
      {content}
    </LinkStyled>
  )
);

Link.propTypes = {
  content: PropTypes.string,
  to: PropTypes.string,
};

Link.defaultProps = {
  content: '',
  to: '',
};

export default Link;
